export { SET_STATE } from '../helper';
import { getFixedFileName, getCORSImageUrl } from '@/utils';

export const RESET_UID = state => {
  state.uid = -1;
};

export const INCREASE_UID = state => {
  state.uid++;
};

export const TOGGLE_COMPARE_MODE = state => {
  state.isCompareMode = !state.isCompareMode;
};

export const SET_UID = (state, uid) => {
  state.uid = uid;
};

export const SET_CURRENT_MENU_ACTION = (state, action) => {
  state.currentMenuAction = action;
};

export const DISCARD_ACTIVE_OBJECT = state => {
  state.selectedObjectUid = -1;
  $XJCanvas && $XJCanvas.discardActiveObject();
};

export const REMOVE_OBJECT_BY_UID = (state, uid) => {
  const { objectPropsMap, objectUIDs, objectMap } = state;
  delete objectPropsMap[uid];
  delete objectMap[uid];
  state.objectUIDs = objectUIDs.filter(i => +i !== +uid);
  state.objectPropsMap = objectPropsMap;
  state.objectMap = objectMap;
  DISCARD_ACTIVE_OBJECT(state);
};

export const REMOVE_SELECTED_OBJECT = state => {
  const uid = state.selectedObjectUid;
  REMOVE_OBJECT_BY_UID(state, uid);
};

export const SET_EDITOR_LOADING = (state, payload) => {
  state.editorLoading = payload;
};

export const patchCropInfo = (state, [patch, isTemp = false]) => {
  if (isTemp) {
    Object.assign(state.cropInfoTemp, patch);
  } else {
    Object.assign(state.cropInfo, patch);
  }
};

export const resetCropInfo = state => {
  state.cropInfo = {};
  state.cropInfoTemp = {
    ratioLabel: '原图',
    ratioValue: 'original',
    changeFlag: 0,
    width: 0,
    height: 0,
    left: 0,
    top: 0,
  };
};

// 如果之前有存储裁剪信息，则还原
export const RESTORE_CROPINFO_TEMP = state => {
  if (Object.keys(state.cropInfo).length > 0) {
    state.cropInfoTemp = { ...state.cropInfo };
  }
};

export const SET_COLOR_PICKING = (state, payload) => {
  state.isColorPicking = payload;
};

export const SET_EDITOR_IMAGE_LOADING = (state, payload) => {
  state.editorImageLoading = payload;
};

export const SET_LOAD_DATA_ERROR = (state, payload) => {
  state.loadDataError = payload;
};

export const SET_CANVAS_GRABING = (state, payload) => {
  state.isCanvasGrabing = payload;
};

export const SET_CANVAS_SCALE = (state, payload) => {
  const { canvasMaxScale, canvasMinScale } = state;
  console.log(111, 'SET_CANVAS_SCALE', payload);
  state.canvasScale = payload > canvasMaxScale ? canvasMaxScale : payload < canvasMinScale ? canvasMinScale : payload;
};

export const SET_SPACEBAR_PRESSED = (state, payload) => {
  state.isSpaceBarPressed = payload;
};

export const SET_READY = state => {
  state.appReady = true;
};

export const SET_IS_UNDO_REDO_RENDERING = (state, payload) => {
  state.isUndoRedoRendering = payload;
};

export const REPLACE_STATE = (state, payload) => {
  const { $IS_FIRST, ...restPayload } = payload;
  // if (!$IS_FIRST) {
  state.isUndoRedoRendering = true;
  // }
  state.objectPropsMap = payload.objectPropsMap;
  state.objectUIDs = payload.objectUIDs;
  if (payload.RmUrl) {
    state.RmUrl = payload.RmUrl;
  }
};

export const SET_SIZE = (state, payload = {}) => {
  Object.assign(state.editorSize, payload);
};
export const SET_COPY_UID = state => {
  state.copyUID = state.selectedObjectUid;
};
export const UPDATE_SELECTED_OBJECT_PROPS = (state, payload) => {
  state.objectPropsMap[state.selectedObjectUid] = payload;
};

export const UPDATE_OBJECT_PROPS = (state, payload) => {
  console.log('UPDATE_OBJECT_PROPS', payload);
  const { uid, props } = payload;
  if (state.objectPropsMap[uid]) {
    Object.assign(state.objectPropsMap[uid], props);
  }
};

export const SET_EDITOR_METADATA = (state, payload) => {
  const { Url, OriginUrl, WatermarkLayerUrl, HasWatermark, OriginUrlRemote } = payload;
  state.OriginUrlRemote = payload.OriginUrlRemote;
  // state.OriginUrl = getCORSImageUrl(payload.OriginUrl);
  state.OriginUrl = payload.OriginUrl;
  state.RmUrl = payload.SslRmUrl || payload.RmUrl || '';
  state.Url = Url;
  state.downloadName = getFixedFileName(OriginUrl);
  state.imageExtenssion = Url.split('.').reverse()[0] || 'png';
  state.WatermarkLayerUrl = WatermarkLayerUrl;
  state.HasWatermark = HasWatermark;
};

// 渲染所有的canvas内容，比如undo/redo，需要清空画布重新渲染一次
export const RENDER_ALL = (state, payload) => {
  state.objectMap = payload.objectMap;
  state.objectPropsMap = payload.objectPropsMap;
  state.objectUIDs = payload.objectUIDs;
  state.cropInfo = payload.cropInfo || {};
};

export const ADD_OBJECT = (state, payload) => {
  let { uid, object, props } = payload;
  const { objectMap, objectPropsMap, objectUIDs } = state;
  objectMap[uid] = object;
  objectUIDs.push(uid);
  objectPropsMap[uid] = { ...props, $$fabricObjectType: object.type };
};
/**
 *
 * @param {*} state
 * @param {Object} payload {props, object}
 */
export const SET_SELECTED_OBJECT_UID = (state, uid) => {
  state.selectedObjectUid = uid;
};

export const SET_DRAWING_CONFIG = (state, payload) => {
  const { brushColor, brushWidth } = payload;
  state.drawingConfig = { ...state.drawingConfig, ...payload };
  const brush = $XJCanvas.freeDrawingBrush;
  if (brushColor) {
    brush.color = payload.brushColor;
  }
  if (brushWidth) {
    brush.width = payload.brushWidth;
  }
};

export const SET_DRAWING_MODE = (state, isDrawingMode) => {
  if (!isDrawingMode) {
    state.isInpaintMode = false;
  }
  state.isDrawingMode = isDrawingMode;
  $XJCanvas.isDrawingMode = isDrawingMode;
  $XJCanvas.freeDrawingCursor = 'none';
  const { canvasScale } = state;
  // 初始化的时候笔刷要可见，大小固定为20px
  state.drawingConfig.brushWidth = parseInt(20 / canvasScale, 10);
  isDrawingMode && SET_DRAWING_CONFIG(state, state.drawingConfig);
};

export const SET_objectUIDs = (state, payload) => {
  state.objectUIDs = payload;
};

export const ADD_MANUAL_SORTED_UIDS = (state, uid) => {
  state.manualSortedUids.push(uid);
};

export const SET_MANUAL_SORTED_UIDS = (state, payload) => {
  state.manualSortedUids = payload;
};

export const SET_USER_INFO = (state, payload = {}) => {
  Object.assign(state.userInfo, payload || {});
};

export const SET_INPAINTING = (state, payload) => {
  state.inpainting = payload;
};

export const SET_INPAINT_CURSOR = (state, payload) => {
  Object.assign(state.inpaintCursorPosition, payload);
};

export const SET_RETURN_BASE64 = (state, payload) => {
  state.returnBase64 = payload;
};
